/**
 * 文件说明:
 * ----------------------------------------
 * 创建用户: leo
 * 创建日期 2019/7/10
 */
import config from 'crm/config'

const authApi = `${config.apiHost}/oem-auth`

export default {
    list: {
        url: `${authApi}/api/users`,
        type: 'GET',
    },
    setRole: {
        url: `${authApi}/api/users/set_role`,
        type: 'PUT',
    },
    changeCreator: {
        url: `${authApi}/api/users/creator`,
        type: 'PUT',
    },
    setDepartment: {
        url: `${authApi}/api/users/set_department`,
        type: 'PUT',
    },
    // 团队管理-更新团队数据
    updateTeamData: {
        url: `${authApi}/api/users/sync`,
        type: 'POST',
    },
    updateTeamDataState: {
        url: `${authApi}/api/users/sync/status/{task_id}`,
        type: 'GET',
    },
    usersIndependent: {
        url: `${authApi}/api/users/independent`,
        type: 'GET',
    },
    usersIndependentDetails: {
        url: `${authApi}/api/users/independent/{id}`,
        type: 'GET',
    },
    exportSensitiveEditExcel: {
        url: `${authApi}/api/users/actions/export`,
        type: 'GET',
    },
}
